// src/extenders/store-locator.js
(function() {
  // The Place Autocomplete clear button lives inside a closed shadow root and its
  // visibility is toggled inline by the component. Intercept attachShadow so we
  // can inject a style override into that shadow root the moment it is created.
  const originalAttachShadow = Element.prototype.attachShadow;
  Element.prototype.attachShadow = function(init) {
    const shadowRoot = originalAttachShadow.call(this, init);
    if (this.tagName && this.tagName.toLowerCase() === "gmp-place-autocomplete") {
      const style = document.createElement("style");
      style.textContent = ".clear-button { visibility: visible !important; }";
      shadowRoot.appendChild(style);
    }
    return shadowRoot;
  };
  const DEV_MODE = false;
  const MARKER_DEFAULT_WIDTH = 27;
  const MARKER_DEFAULT_HEIGHT = 40;
  const MARKER_BIGGER_WIDTH = 37;
  const MARKER_BIGGER_HEIGHT = 54;
  const FOCUS_MARKER_MIN_ZOOM = 13;
  const CURRENT_LOCATION_FOCUS_ZOOM = 12;
  const CACHE_TIMEOUT = 24 * 60 * 60;
  const MARKER_MAX_ZINDEX = 1000000;
  const ACTIVE_CUSTOMER_GROUPS = ["CORE", "STARTER", "CERTIFIED", "CERTIFIED PLUS", "PREMIUM", "PREMIUM PLUS", "E-PREMIUM", "E-PREMIUM PLUS", "E-CERTIFIED", "E-CERTIFIED PLUS"];
  function debugLog(message, data) {
    if (!DEV_MODE)
      return;
    data !== void 0 ? console.log(`[StoreLocator] ${message}`, data) : console.log(`[StoreLocator] ${message}`);
  }
  function debugWarn(message, data) {
    if (!DEV_MODE)
      return;
    data !== void 0 ? console.warn(`[StoreLocator] ${message}`, data) : console.warn(`[StoreLocator] ${message}`);
  }
  function debugError(message, data) {
    if (!DEV_MODE)
      return;
    data !== void 0 ? console.error(`[StoreLocator] ${message}`, data) : console.error(`[StoreLocator] ${message}`);
  }
  const config = getConfig();
  let map;
  let infoWindow;
  let markerIcon;
  let companiesRef;
  let pacInput;
  let sidebar;
  let loader;
  let currentPositionMarker;
  let markerClusters;
  let activeMarker = null;
  let activeSidebarItem = null;
  let geocoder;
  let markers = [];
  let markersInfo = [];
  let currentPosition = { ...config.defaultCenter };
  const clusterRenderer = {
    render: ({ count, position }) => {
      const fillColor = count > 10 ? "#FF8F1C" : "#F8CFA9";
      const content = document.createElement("div");
      content.className = "store-cluster-marker";
      content.innerHTML = `
        <svg fill="${fillColor}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
          <circle cx="120" cy="120" opacity=".8" r="70" />
        </svg>
        <span>${count}</span>
      `;
      return new google.maps.marker.AdvancedMarkerElement({
        position,
        content,
        zIndex: MARKER_MAX_ZINDEX + count
      });
    }
  };
  function getConfig() {
    const configNode = document.getElementById("store-locator-config");
    if (!configNode) {
      debugWarn("Config node not found, using fallback config");
      return {
        collectionName: "Companies-Image-Skincare",
        defaultCenter: {
          lat: 51.83980235388652,
          lng: 4.959942736402793
        },
        defaultRadiusKm: 250,
        mapId: "c4e23395d6831d91",
        assetUrls: {
          marker: "",
          expertBadge: "",
          advancedExpertBadge: ""
        },
        labels: {
          defaultLocation: "Nederland",
          loadingLocation: "Je locatie vinden...",
          noResults: "Geen resultaten gevonden.",
          loadError: "Er ging iets mis bij het laden van de salons.",
          locationNotFound: "Geen locatie gevonden voor deze zoekopdracht.",
          appointment: "Afspraak plannen",
          expert: "Expert",
          advancedExpert: "Advanced expert",
          call: "Bel",
          whatsapp: "WhatsApp",
          email: "Mail",
          website: "Website",
          instagram: "Instagram",
          facebook: "Facebook",
          tiktok: "TikTok",
          close: "Sluiten"
        }
      };
    }
    try {
      const parsedConfig = JSON.parse(configNode.textContent);
      debugLog("Parsed config node successfully");
      return parsedConfig;
    } catch (error) {
      debugError("Invalid store locator config", error);
      return {
        collectionName: "Companies-Image-Skincare",
        defaultCenter: {
          lat: 51.83980235388652,
          lng: 4.959942736402793
        },
        defaultRadiusKm: 250,
        mapId: "c4e23395d6831d91",
        assetUrls: {
          marker: "",
          expertBadge: "",
          advancedExpertBadge: ""
        },
        labels: {
          defaultLocation: "Nederland",
          loadingLocation: "Je locatie vinden...",
          noResults: "Geen resultaten gevonden.",
          loadError: "Er ging iets mis bij het laden van de salons.",
          locationNotFound: "Geen locatie gevonden voor deze zoekopdracht.",
          appointment: "Afspraak plannen",
          expert: "Expert",
          advancedExpert: "Advanced expert",
          call: "Bel",
          whatsapp: "WhatsApp",
          email: "Mail",
          website: "Website",
          instagram: "Instagram",
          facebook: "Facebook",
          tiktok: "TikTok",
          close: "Sluiten"
        }
      };
    }
  }
  function escapeHtml(value) {
    return String(value != null ? value : "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
  }
  function normalizeExternalUrl(value) {
    const trimmedValue = String(value != null ? value : "").trim();
    if (!trimmedValue) {
      return "";
    }
    if (/^https?:\/\//i.test(trimmedValue)) {
      return trimmedValue;
    }
    return `https://${trimmedValue.replace(/^\/+/, "")}`;
  }
  function normalizePhoneNumber(value) {
    return String(value != null ? value : "").trim().replace(/[^\d+]/g, "");
  }
  function normalizeWhatsAppNumber(value) {
    return String(value != null ? value : "").trim().replace(/[^\d]/g, "");
  }
  function getCache() {
    if (!window.ls || typeof window.ls.get !== "function" || typeof window.ls.set !== "function") {
      debugWarn("localstorage-slim is unavailable, cache disabled");
      return null;
    }
    return window.ls;
  }
  function haversineDistance(lat1, lng1, lat2, lng2) {
    const earthRadiusKm = 6371;
    const dLat = (lat2 - lat1) * (Math.PI / 180);
    const dLng = (lng2 - lng1) * (Math.PI / 180);
    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(lat1 * (Math.PI / 180)) * Math.cos(lat2 * (Math.PI / 180)) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return earthRadiusKm * (2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)));
  }
  function showLoader() {
    if (loader) {
      loader.style.cssText = "display: flex !important";
    }
  }
  function hideLoader() {
    if (loader) {
      loader.style.cssText = "display: none !important";
    }
  }
  function clearSidebar() {
    if (sidebar) {
      sidebar.innerHTML = "";
    }
  }
  function showSidebarMessage(message) {
    if (!sidebar) {
      debugWarn("Sidebar element missing, cannot show message", message);
      return;
    }
    debugLog("Sidebar message:", message);
    const messageElement = document.createElement("div");
    messageElement.className = "list-group-item bg-gray";
    messageElement.textContent = message;
    sidebar.appendChild(messageElement);
  }
  function setMarkerSize(marker, expanded) {
    if (!marker || !markerIcon) {
      return;
    }
    const size = expanded ? markerIcon.biggerSize : markerIcon.defaultSize;
    const content = marker.content;
    if (content && content.style) {
      content.style.width = `${size.width}px`;
      content.style.height = `${size.height}px`;
    }
  }
  function resetActiveState() {
    if (activeMarker) {
      setMarkerSize(activeMarker, false);
      activeMarker = null;
    }
    if (activeSidebarItem) {
      activeSidebarItem.classList.remove("active", "bg-white");
      activeSidebarItem = null;
    }
  }
  function clearMarkers() {
    debugLog("Clearing markers", {
      markerCount: markers.length,
      hasClusterer: Boolean(markerClusters)
    });
    resetActiveState();
    if (markerClusters) {
      markerClusters.clearMarkers();
      markerClusters = null;
    }
    markers.forEach((marker) => {
      marker.map = null;
    });
    markers = [];
  }
  function renderBadge(imageUrl, label) {
    if (!imageUrl) {
      return "";
    }
    return `
      <div class="mb-2 d-flex align-items-center">
        <img src="${escapeHtml(imageUrl)}" alt="${escapeHtml(label)}" width="40">
        <p class="m-0 ml-2">${escapeHtml(label)}</p>
      </div>
    `;
  }
  function renderLink(href, label, className = "") {
    if (!href || !label) {
      return "";
    }
    const isExternalLink = /^https?:\/\//i.test(href);
    const target = isExternalLink ? ' target="_blank" rel="noopener noreferrer"' : "";
    return `<a class="${className}" href="${escapeHtml(href)}"${target}>${escapeHtml(label)}</a>`;
  }
  function renderInfoWindow(store) {
    var _a;
    const phoneNumber = normalizePhoneNumber(store.telephone);
    const whatsAppNumber = normalizeWhatsAppNumber(store.whatsApp);
    const emailAddress = String((_a = store.email) != null ? _a : "").trim();
    const appointmentUrl = normalizeExternalUrl(store.appointmentUrl);
    const websiteUrl = normalizeExternalUrl(store.website);
    const instagramUrl = normalizeExternalUrl(store.instagramUrl);
    const facebookUrl = normalizeExternalUrl(store.facebookUrl);
    const tiktokUrl = normalizeExternalUrl(store.tiktokUrl);
    const badges = [
      store.isExpert ? renderBadge(config.assetUrls.expertBadge, config.labels.expert) : "",
      store.isAdvancedExpert ? renderBadge(config.assetUrls.advancedExpertBadge, config.labels.advancedExpert) : ""
    ].filter(Boolean).join("");
    const contactLinks = [
      phoneNumber ? renderLink(`tel:${phoneNumber}`, `${config.labels.call} (${store.telephone})`, "mb-2") : "",
      whatsAppNumber ? renderLink(`https://wa.me/${whatsAppNumber}`, `${config.labels.whatsapp} (${store.whatsApp})`, "mb-2") : "",
      emailAddress ? renderLink(`mailto:${emailAddress}`, `${config.labels.email} (${emailAddress})`) : ""
    ].filter(Boolean).join("");
    const socialLinks = [
      websiteUrl ? `<div class="social-icon web-icon">
            <a href="${escapeHtml(websiteUrl)}" target="_blank" rel="noopener noreferrer">
              <img src="${escapeHtml(config.assetUrls.socialWebsite)}" alt="${escapeHtml(config.labels.website)}" width="40" height="40">
            </a>
          </div>` : "",
      instagramUrl ? `<div class="ml-2 social-icon instagram-icon">
            <a href="${escapeHtml(instagramUrl)}" target="_blank" rel="noopener noreferrer">
              <img src="${escapeHtml(config.assetUrls.socialInstagram)}" alt="${escapeHtml(config.labels.instagram)}" width="40" height="40">
            </a>
          </div>` : "",
      facebookUrl ? `<div class="ml-2 social-icon facebook-icon">
            <a href="${escapeHtml(facebookUrl)}" target="_blank" rel="noopener noreferrer">
              <img src="${escapeHtml(config.assetUrls.socialFacebook)}" alt="${escapeHtml(config.labels.facebook)}" width="40" height="40">
            </a>
          </div>` : "",
      tiktokUrl ? `<div class="ml-2 social-icon tiktok-icon">
            <a href="${escapeHtml(tiktokUrl)}" target="_blank" rel="noopener noreferrer">
              <img src="${escapeHtml(config.assetUrls.socialTiktok)}" alt="${escapeHtml(config.labels.tiktok)}" width="40" height="40">
            </a>
          </div>` : ""
    ].filter(Boolean).join("");
    return `
      <div class="marker-info-window">
        <div class="mb-4">
          <div class="flex-row d-flex justify-content-between align-items-center">
            <h4 class="text-uppercase title">${escapeHtml(store.title)}</h4>
            <button
              type="button"
              class="border-0 info-window-close-button"
              aria-label="${escapeHtml(config.labels.close)}"
            >
              &times;
            </button>
          </div>
          <p class="address">${escapeHtml(store.address)}</p>
        </div>
        ${badges}
        ${contactLinks ? `<div class="mb-4 d-flex flex-column contact-icons">${contactLinks}</div>` : ""}
        ${appointmentUrl ? renderLink(appointmentUrl, config.labels.appointment, "mb-4 store-locator-btn") : ""}
        ${socialLinks ? `<div class="flex-row d-flex social-icons">${socialLinks}</div>` : ""}
      </div>
    `;
  }
  function selectSidebarItem(sidebarItem) {
    if (!sidebarItem) {
      return;
    }
    if (activeSidebarItem && activeSidebarItem !== sidebarItem) {
      activeSidebarItem.classList.remove("active", "bg-white");
    }
    sidebarItem.classList.add("active", "bg-white");
    activeSidebarItem = sidebarItem;
  }
  function openMarker(marker, options = {}) {
    var _a, _b;
    if (!marker) {
      debugWarn("openMarker called without marker");
      return;
    }
    debugLog("Opening marker", {
      title: (_a = marker.storeLocatorData) == null ? void 0 : _a.title,
      panTo: options.panTo !== false
    });
    if (activeMarker && activeMarker !== marker) {
      setMarkerSize(activeMarker, false);
    }
    activeMarker = marker;
    setMarkerSize(marker, true);
    selectSidebarItem(marker.sidebarItem);
    infoWindow.setContent(renderInfoWindow(marker.storeLocatorData));
    const shouldPanToMarker = options.panTo !== false;
    const shouldZoomToMarker = options.zoomTo !== false;
    const currentZoom = (_b = map.getZoom()) != null ? _b : 0;
    const shouldApplyFocusZoom = shouldZoomToMarker && currentZoom < FOCUS_MARKER_MIN_ZOOM;
    const markerPosition = marker.position;
    const openInfoWindow = () => {
      infoWindow.open({
        map,
        anchor: marker
      });
    };
    if (shouldPanToMarker) {
      google.maps.event.addListenerOnce(map, "idle", () => {
        map.setCenter(markerPosition);
        if (shouldApplyFocusZoom) {
          map.setZoom(FOCUS_MARKER_MIN_ZOOM);
        }
        openInfoWindow();
      });
      map.panTo(markerPosition);
    } else if (shouldApplyFocusZoom) {
      map.setZoom(FOCUS_MARKER_MIN_ZOOM);
      google.maps.event.addListenerOnce(map, "idle", openInfoWindow);
    } else {
      openInfoWindow();
    }
    google.maps.event.addListenerOnce(infoWindow, "domready", () => {
      const closeButton = document.querySelector(".info-window-close-button");
      if (closeButton) {
        closeButton.addEventListener("click", () => {
          resetActiveState();
          infoWindow.close();
        });
      }
    });
  }
  function createMarker(store) {
    const img = document.createElement("img");
    img.src = markerIcon.url;
    img.style.width = `${markerIcon.defaultSize.width}px`;
    img.style.height = `${markerIcon.defaultSize.height}px`;
    const marker = new google.maps.marker.AdvancedMarkerElement({
      map,
      title: store.title,
      position: store.position,
      content: img,
      gmpClickable: true
    });
    marker.storeLocatorData = store;
    marker.addEventListener("gmp-click", () => {
      openMarker(marker);
    });
    markers.push(marker);
    return marker;
  }
  function createMarkers() {
    debugLog("Creating all markers", {
      markersInfoCount: markersInfo.length
    });
    markersInfo.forEach((store) => {
      createMarker(store);
    });
    if (markers.length > 0 && window.markerClusterer && typeof window.markerClusterer.MarkerClusterer === "function") {
      markerClusters = new window.markerClusterer.MarkerClusterer({
        markers,
        map,
        renderer: clusterRenderer
      });
      debugLog("Marker clusterer created", {
        markerCount: markers.length
      });
    }
  }
  function updateMapViewport() {
    var _a;
    if (!map) {
      debugWarn("updateMapViewport called before map is ready");
      return;
    }
    debugLog("updateMapViewport: start", {
      markerCount: markers.length,
      currentPosition,
      currentZoom: map.getZoom(),
      currentCenter: (_a = map.getCenter()) == null ? void 0 : _a.toJSON()
    });
    if (markers.length === 0) {
      debugLog("updateMapViewport: no markers \u2192 centering on currentPosition at zoom 8");
      map.setCenter(currentPosition);
      map.setZoom(8);
      return;
    }
    if (markers.length === 1) {
      debugLog("updateMapViewport: single marker \u2192 centering on marker at zoom 11");
      map.setCenter(markers[0].position);
      map.setZoom(11);
      return;
    }
    const bounds = new google.maps.LatLngBounds();
    markers.forEach((marker) => {
      bounds.extend(marker.position);
    });
    if (currentPositionMarker) {
      bounds.extend(currentPositionMarker.position);
    }
    debugLog("updateMapViewport: fitting bounds to markers (this will zoom out)", {
      markerCount: markers.length,
      boundsNE: bounds.getNorthEast().toJSON(),
      boundsSW: bounds.getSouthWest().toJSON(),
      zoomBefore: map.getZoom()
    });
    map.fitBounds(bounds, 64);
  }
  function keepCurrentLocationInView() {
    var _a;
    if (!map) {
      return;
    }
    map.setCenter(currentPosition);
    const currentZoom = (_a = map.getZoom()) != null ? _a : 0;
    if (currentZoom < CURRENT_LOCATION_FOCUS_ZOOM) {
      map.setZoom(CURRENT_LOCATION_FOCUS_ZOOM);
    }
  }
  function createSideBar() {
    if (!sidebar) {
      debugWarn("Sidebar element not found");
      return;
    }
    debugLog("Rendering sidebar", {
      markerCount: markers.length
    });
    if (markers.length === 0) {
      showSidebarMessage(config.labels.noResults);
      return;
    }
    const fragment = document.createDocumentFragment();
    markers.forEach((marker) => {
      const store = marker.storeLocatorData;
      const sidebarItem = document.createElement("button");
      sidebarItem.type = "button";
      sidebarItem.className = "list-group-item list-group-item-action lh-tight bg-gray border-0 w-100";
      sidebarItem.innerHTML = `
        <div class="flex-row d-flex justify-content-between">
          <div>
            <h4 class="mb-1 text-uppercase title">${escapeHtml(store.title)}</h4>
            <div class="mb-1 col-10 small">${escapeHtml(store.shortAddress || store.address)}</div>
          </div>
          <div class="featured-icon">
            ${store.isExpert ? `<img src="${escapeHtml(config.assetUrls.expertBadge)}" alt="${escapeHtml(config.labels.expert)}" width="40">` : ""}
            ${store.isAdvancedExpert ? `<img src="${escapeHtml(config.assetUrls.advancedExpertBadge)}" alt="${escapeHtml(config.labels.advancedExpert)}" width="40">` : ""}
          </div>
        </div>
      `;
      sidebarItem.addEventListener("click", () => {
        openMarker(marker);
      });
      marker.sidebarItem = sidebarItem;
      fragment.appendChild(sidebarItem);
    });
    sidebar.appendChild(fragment);
  }
  function updateCurrentPositionMarker(latitude, longitude) {
    debugLog("updateCurrentPositionMarker: panning + zooming to searched location (zoom-in phase)", {
      previousPosition: currentPosition,
      nextPosition: { lat: latitude, lng: longitude },
      zoomBefore: map.getZoom(),
      targetZoom: CURRENT_LOCATION_FOCUS_ZOOM
    });
    currentPosition = { lat: latitude, lng: longitude };
    if (currentPositionMarker) {
      currentPositionMarker.position = currentPosition;
    }
    map.panTo(currentPosition);
    map.setZoom(CURRENT_LOCATION_FOCUS_ZOOM);
    debugLog("updateCurrentPositionMarker: pan + zoom applied, Firestore fetch will follow");
  }
  function getGeocoder() {
    if (!geocoder) {
      geocoder = new google.maps.Geocoder();
    }
    return geocoder;
  }
  function updateSearchInputFromLocation(latitude, longitude) {
    if (!pacInput) {
      debugWarn("Search input missing while reverse geocoding");
      return;
    }
    debugLog("Reverse geocoding current position", {
      latitude,
      longitude
    });
    getGeocoder().geocode({ location: { lat: latitude, lng: longitude } }, (results, status) => {
      debugLog("Reverse geocode response", {
        status,
        resultCount: Array.isArray(results) ? results.length : 0
      });
      if (status !== "OK" || !Array.isArray(results) || results.length === 0) {
        pacInput.value = config.labels.defaultLocation;
        return;
      }
      const localityResult = results.find(
        (result) => {
          var _a;
          return (_a = result.address_components) == null ? void 0 : _a.some((component) => component.types.includes("locality"));
        }
      );
      pacInput.value = (localityResult == null ? void 0 : localityResult.formatted_address) || results[0].formatted_address || config.labels.defaultLocation;
    });
  }
  function initFirebase() {
    if (!window.firebase) {
      throw new Error("Firebase is unavailable.");
    }
    debugLog("Initializing Firebase");
    const firebaseConfig = {
      apiKey: "AIzaSyBKFDksiTg-x5szGEEMxhQz75D4_o4agGk",
      projectId: "superb-app-380511"
    };
    if (!firebase.apps.length) {
      firebase.initializeApp(firebaseConfig);
      debugLog("Firebase app initialized");
    } else {
      debugLog("Reusing existing Firebase app", {
        appCount: firebase.apps.length
      });
    }
    companiesRef = firebase.firestore().collection(config.collectionName);
    debugLog("Firestore collection ready", {
      collectionName: config.collectionName
    });
  }
  async function getCompanies(radiusInKm = null, options = {}) {
    var _a, _b;
    const preserveCurrentLocationViewport = options.preserveCurrentLocationViewport === true;
    debugLog("Loading companies", {
      radiusInKm,
      currentPosition,
      preserveCurrentLocationViewport
    });
    clearMarkers();
    clearSidebar();
    showLoader();
    try {
      const cache = getCache();
      const center = [currentPosition.lat, currentPosition.lng];
      const cacheKey = `${center.join(",")}-${radiusInKm || "noRadius"}`;
      const cachedData = cache ? cache.get(cacheKey) : null;
      if (Array.isArray(cachedData)) {
        debugLog("getCompanies: using cached companies", {
          cacheKey,
          resultCount: cachedData.length
        });
        markersInfo = cachedData;
        createMarkers();
        createSideBar();
        if (preserveCurrentLocationViewport) {
          debugLog("getCompanies (cache): preserving current location viewport");
          keepCurrentLocationInView();
        } else {
          debugLog("getCompanies (cache): calling updateMapViewport \u2192 zoom-out phase begins now");
          updateMapViewport();
        }
        return;
      }
      const visibleCompaniesRef = companiesRef.where("isHidden", "==", false).where("customerGroup", "in", ACTIVE_CUSTOMER_GROUPS);
      const queries = [];
      let usesGeohashQuery = false;
      if (radiusInKm && typeof geohashQueryBounds === "function") {
        const radiusInM = radiusInKm * 1e3;
        const bounds = geohashQueryBounds(center, radiusInM);
        usesGeohashQuery = true;
        debugLog("Using geohash bounds query", {
          boundsCount: bounds.length,
          radiusInM
        });
        bounds.forEach(([start, end]) => {
          queries.push(visibleCompaniesRef.orderBy("geohash").startAt(start).endAt(end).get());
        });
      } else {
        debugLog("Using full collection query", {
          hasGeoHashQueryBounds: typeof geohashQueryBounds === "function"
        });
        queries.push(visibleCompaniesRef.get());
      }
      let snapshots;
      try {
        snapshots = await Promise.all(queries);
      } catch (error) {
        if (!usesGeohashQuery) {
          throw error;
        }
        debugWarn("Geohash query failed, retrying with full collection query", error);
        snapshots = [await visibleCompaniesRef.get()];
      }
      debugLog("Firestore queries resolved", {
        queryCount: queries.length,
        snapshotSizes: snapshots.map((snapshot) => snapshot.docs.length)
      });
      const matchingDocs = [];
      const seenDocumentIds = /* @__PURE__ */ new Set();
      snapshots.forEach((snapshot) => {
        snapshot.docs.forEach((doc) => {
          var _a2;
          if (seenDocumentIds.has(doc.id)) {
            return;
          }
          seenDocumentIds.add(doc.id);
          const data = doc.data();
          const coordinates = data.coordinates;
          const latitude = coordinates == null ? void 0 : coordinates.latitude;
          const longitude = coordinates == null ? void 0 : coordinates.longitude;
          if (typeof latitude !== "number" || typeof longitude !== "number") {
            return;
          }
          const distance = haversineDistance(currentPosition.lat, currentPosition.lng, latitude, longitude);
          if (radiusInKm && distance > radiusInKm) {
            return;
          }
          const certificate = String((_a2 = data.certificate) != null ? _a2 : "").trim().toLowerCase();
          matchingDocs.push({
            title: data.name || data.coordinateAddress || config.labels.defaultLocation,
            address: data.coordinateAddress || data.shortAddress || "",
            shortAddress: data.shortAddress || data.coordinateAddress || "",
            position: { lat: latitude, lng: longitude },
            telephone: data.telephone || "",
            whatsApp: data.whatsApp || "",
            email: data.primaryEmail || "",
            appointmentUrl: data.appointmentUrl || "",
            website: data.website || "",
            instagramUrl: data.instagramUrl || "",
            facebookUrl: data.facebookUrl || "",
            tiktokUrl: data.tiktokUrl || "",
            isExpert: certificate === "expert",
            isAdvancedExpert: certificate === "advanced expert",
            distance
          });
        });
      });
      matchingDocs.sort((storeA, storeB) => storeA.distance - storeB.distance);
      debugLog("Companies prepared", {
        resultCount: matchingDocs.length,
        firstResult: ((_a = matchingDocs[0]) == null ? void 0 : _a.title) || null
      });
      if (cache) {
        cache.set(cacheKey, matchingDocs, { ttl: CACHE_TIMEOUT });
        debugLog("Stored companies in cache", {
          cacheKey,
          resultCount: matchingDocs.length
        });
      }
      markersInfo = matchingDocs;
      createMarkers();
      createSideBar();
      if (preserveCurrentLocationViewport) {
        debugLog("getCompanies: preserving current location viewport (keepCurrentLocationInView)");
        keepCurrentLocationInView();
      } else {
        debugLog("getCompanies: calling updateMapViewport \u2192 zoom-out phase begins now");
        updateMapViewport();
      }
    } catch (error) {
      debugError("Unable to load store locator results", error);
      showSidebarMessage(config.labels.loadError);
    } finally {
      hideLoader();
      debugLog("getCompanies: finished loading companies", {
        markerCount: markers.length,
        finalZoom: map == null ? void 0 : map.getZoom(),
        finalCenter: (_b = map == null ? void 0 : map.getCenter()) == null ? void 0 : _b.toJSON()
      });
    }
  }
  function getSelectedDistance() {
    const distanceDropdown = document.getElementById("distance-dropdown");
    if (!distanceDropdown) {
      return config.defaultRadiusKm;
    }
    const selectedDistance = Number.parseFloat(distanceDropdown.value);
    return Number.isFinite(selectedDistance) ? selectedDistance : config.defaultRadiusKm;
  }
  function getCompaniesWithSelectedDistance(options = {}) {
    const selectedDistance = getSelectedDistance();
    debugLog("Loading companies with selected distance", {
      selectedDistance,
      preserveCurrentLocationViewport: options.preserveCurrentLocationViewport === true
    });
    return getCompanies(selectedDistance, options);
  }
  function searchByInputValue() {
    if (!pacInput) {
      debugWarn("Search input missing");
      return;
    }
    const query = pacInput.value.trim();
    debugLog("Searching by input value", {
      query
    });
    if (!query) {
      pacInput.value = config.labels.defaultLocation;
      updateCurrentPositionMarker(config.defaultCenter.lat, config.defaultCenter.lng);
      getCompaniesWithSelectedDistance();
      return;
    }
    getGeocoder().geocode({ address: query }, (results, status) => {
      var _a, _b;
      debugLog("Search geocode response", {
        query,
        status,
        resultCount: Array.isArray(results) ? results.length : 0
      });
      if (status !== "OK" || !Array.isArray(results) || !((_b = (_a = results[0]) == null ? void 0 : _a.geometry) == null ? void 0 : _b.location)) {
        window.alert(config.labels.locationNotFound);
        return;
      }
      const location = results[0].geometry.location;
      updateCurrentPositionMarker(location.lat(), location.lng());
      getCompaniesWithSelectedDistance({ preserveCurrentLocationViewport: true });
    });
  }
  async function initPlacesAutoComplete() {
    if (!pacInput) {
      debugWarn("Autocomplete not initialized", {
        hasPacInput: Boolean(pacInput)
      });
      return;
    }
    debugLog("Initializing Places autocomplete");
    const placesLib = await google.maps.importLibrary("places");
    const PlaceAutocompleteElement = placesLib && placesLib.PlaceAutocompleteElement;
    if (!PlaceAutocompleteElement) {
      debugWarn("PlaceAutocompleteElement unavailable");
      return;
    }
    const placeAutocomplete = new PlaceAutocompleteElement({
      includedRegionCodes: ["nl", "be"]
    });
    placeAutocomplete.id = pacInput.id;
    placeAutocomplete.className = pacInput.className;
    if (pacInput.value) {
      placeAutocomplete.value = pacInput.value;
    }
    pacInput.parentNode.replaceChild(placeAutocomplete, pacInput);
    pacInput = placeAutocomplete;
    placeAutocomplete.addEventListener("gmp-select", async ({ placePrediction }) => {
      const place = placePrediction.toPlace();
      await place.fetchFields({ fields: ["location"] });
      debugLog("Autocomplete place selected", {
        hasLocation: Boolean(place.location)
      });
      if (!place.location) {
        window.alert(config.labels.locationNotFound);
        return;
      }
      updateCurrentPositionMarker(place.location.lat(), place.location.lng());
      getCompaniesWithSelectedDistance({ preserveCurrentLocationViewport: true });
    });
  }
  function getUserLocation() {
    if (!("geolocation" in navigator) || !pacInput) {
      debugWarn("Geolocation unavailable", {
        hasGeolocation: "geolocation" in navigator,
        hasPacInput: Boolean(pacInput)
      });
      return;
    }
    debugLog("Requesting user location");
    pacInput.disabled = true;
    pacInput.value = config.labels.loadingLocation;
    navigator.geolocation.getCurrentPosition(
      (position) => {
        pacInput.disabled = false;
        debugLog("Geolocation success", {
          latitude: position.coords.latitude,
          longitude: position.coords.longitude
        });
        updateCurrentPositionMarker(position.coords.latitude, position.coords.longitude);
        updateSearchInputFromLocation(position.coords.latitude, position.coords.longitude);
        getCompaniesWithSelectedDistance({ preserveCurrentLocationViewport: true });
      },
      (error) => {
        pacInput.disabled = false;
        pacInput.value = config.labels.defaultLocation;
        debugError("Unable to get current location", error);
      }
    );
  }
  function initGetLocation() {
    const getLocationButton = document.getElementById("get-location");
    if (!getLocationButton) {
      debugWarn("Get location button not found");
      return;
    }
    debugLog("Binding get location button");
    getLocationButton.addEventListener("click", getUserLocation);
  }
  function initSearch() {
    const searchButton = document.getElementById("search-btn");
    if (searchButton) {
      debugLog("Binding search button");
      searchButton.addEventListener("click", searchByInputValue);
    } else {
      debugLog("Search button not present, relying on Enter/autocomplete");
    }
    if (pacInput) {
      debugLog("Binding search input keyboard handler");
      pacInput.addEventListener("keydown", (event) => {
        if (event.key === "Enter") {
          event.preventDefault();
          searchByInputValue();
        }
      });
    }
  }
  async function initMap() {
    var _a, _b;
    if (window.__storeLocatorInitCompleted) {
      debugLog("initMap already completed, skipping duplicate callback");
      return;
    }
    if (!document.getElementById("map")) {
      debugWarn("Map element not found, aborting init");
      return;
    }
    debugLog("initMap called", {
      hasGoogle: Boolean(window.google),
      hasImportLibrary: Boolean((_b = (_a = window.google) == null ? void 0 : _a.maps) == null ? void 0 : _b.importLibrary),
      currentPosition
    });
    const [{ Map }] = await Promise.all([
      google.maps.importLibrary("maps"),
      google.maps.importLibrary("marker")
    ]);
    debugLog("Google Maps library loaded");
    map = new Map(document.getElementById("map"), {
      center: currentPosition,
      zoom: 8,
      mapId: config.mapId,
      mapTypeControl: false,
      streetViewControl: false
    });
    sidebar = document.getElementById("sidebar");
    loader = document.getElementById("loader");
    pacInput = document.getElementById("pac-input");
    debugLog("DOM elements resolved", {
      hasSidebar: Boolean(sidebar),
      hasLoader: Boolean(loader),
      hasPacInput: Boolean(pacInput)
    });
    if (pacInput && !pacInput.value.trim()) {
      pacInput.value = config.labels.defaultLocation;
    }
    infoWindow = new google.maps.InfoWindow({
      disableAutoPan: true
    });
    infoWindow.addListener("closeclick", resetActiveState);
    markerIcon = {
      url: config.assetUrls.marker,
      defaultSize: { width: MARKER_DEFAULT_WIDTH, height: MARKER_DEFAULT_HEIGHT },
      biggerSize: { width: MARKER_BIGGER_WIDTH, height: MARKER_BIGGER_HEIGHT }
    };
    currentPositionMarker = new google.maps.marker.AdvancedMarkerElement({
      map,
      position: currentPosition
    });
    debugLog("Current position marker created", {
      currentPosition
    });
    initFirebase();
    await getCompanies();
    await initPlacesAutoComplete();
    initGetLocation();
    initSearch();
    window.__storeLocatorInitCompleted = true;
    debugLog("Store locator initialization complete");
  }
  window.__storeLocatorRunInitMap = initMap;
  if (window.__storeLocatorInitRequested) {
    debugLog("Google Maps callback already fired, starting deferred initialization now");
    window.__storeLocatorRunInitMap();
  } else {
    debugLog("Waiting for Google Maps callback");
  }
})();
